<div class="card mt-2">
  <div class="card-header">
    <div class="card-header-title">
      Vehicles
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-sm card-table table-wrap" aria-labelledby="tableLabel" *ngIf="vehicleJobPage">
      <thead>
        <tr>
          <th class="vehicle text-center"></th>
          <th class="departed">Dep</th>
          <th class="location">From Location</th>
          <th class="asset text-center">Cont</th>
          <th class="time text-center">Time</th>
          <th class="mileage text-center">Mileage</th>
          <th class="location">To location</th>
          <th class="arrived">Arr</th>      
          <th class="var1 text-center" *ngIf="showVariance()" title="Journey Time Variance">TVA</th>
          <th class="var2 text-center" *ngIf="showVariance()" title="Mileage Time Variance">MVA</th>
        </tr>
      </thead>
      <tbody *ngFor="let vehicle of vehicleJobPage">
        <tr *ngFor="let job of vehicle.jobItems">
            <td class="vehicle text-center" *ngIf="job.isFirstRow" rowspan="3">{{ vehicle.vehicleName }}</td>
            <td (click)="goToRouteMap(job.movementId)" title="{{ job.departedAt | date:'mediumDate' }}" id="departed" class="departed" [className]="job.alert ? 'departed warning' : 'departed'"><div class="trunc">{{ job.departedAtFormatted }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" class="location" [className]="job.alert ? 'warning location' : 'location'"><div class="trunc">{{ job.fromLocation }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" class="asset text-center" [className]="job.alert ? 'warning asset text-center' : 'asset text-center'"><div class="trunc">{{ job.containerId }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" class="time text-center" [className]="job.alert ? 'warning time text-center' : 'time text-center'"><div class="trunc">{{ job.journeyTimeMinutesFormatted }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" class="mileage text-center" [className]="job.alert ? 'warning mileage text-center' : 'mileage text-center'"><div class="trunc">{{ job.mileageFormatted }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" class="location" [className]="job.alert ? 'warning location' : 'location'"><div class="trunc">{{ job.toLocation }}</div></td>
            <td (click)="goToRouteMap(job.movementId)"title="{{ job.arrivedAt | date:'mediumDate' }}" class="arrived text-center" [className]="job.alert ? 'warning arrived' : 'arrived'"><div class="trunc">{{ job.arrivedAtFormatted }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" *ngIf="showVariance()" class="var1 text-center" [className]="job.alert ? 'warning var1 text-center' : 'var1 text-center'"><div [className]="job.variance == 0 ? 'trunc' : job.variance > 0 ? 'warning trunc' : 'good trunc'">{{ job.variance }}</div></td>
            <td (click)="goToRouteMap(job.movementId)" *ngIf="showVariance()" class="var2 text-center" [className]="job.alert ? 'warning var2 text-center' : 'var2 text-center'"><div [className]="job.mileageVariance == 0 ? 'trunc' : job.mileageVariance > 0 ? 'warning trunc' : 'good trunc'">{{ job.mileageVarianceFormatted }}</div></td>
        </tr>
        </tbody>
        <tbody class="list">
          <tr>
              <td class="h-2" colspan="8"></td>
          </tr>
      </tbody> 
    </table>
  </div>
</div>
